import { useState } from "react";
import { useSavedSettings } from "@utils/hooks/useSavedSettings";
import { IAddNewMinerProps } from "./AddNewMiner.props";
import { ISavedMinerSetting } from "@store/savedMinerSettings/actionTypes";
import { ALGOS_E } from "@constants/Algos";
import {
  IAddMinerParams,
  AddMinerReuest,
  NewMinerI,
} from "@services/addNewMiner";
import useApiRequests from "@services/http/useApiRequest";
import { makeNotifs } from "@utils/makeNotifs";
import { useDispatch, useSelector } from "react-redux";
import { addNewMiner as addNewMinerToStore } from "@store/storedMiners/actions";
import { RecordResponse } from "@services/http/responses/BaseResponse";
import { RootState } from "@store";
import { Tab } from "@store/minersSelect/actionTypes";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";

export const useAddNewMinerControl = (props: IAddNewMinerProps) => {
  const savedSettings = useSavedSettings();
  const notifs = makeNotifs();
  const requests = useApiRequests();
  const { onSuccess, onLoader } = useGlobalNotifs();
  const dispatch = useDispatch();
  const selectedMinerTableTab = useSelector(
    (state: RootState) => state.minersSelect.tab
  );

  const [loading, setLoading] = useState(false);

  const hasClonedSetting = savedSettings.length > 0;

  const onAddMiner = async () => {
    setLoading(true);
    let settings: IAddMinerParams = {
      hash: ALGOS_E.SHA256,
    };
    const response = await requests.enqueue<RecordResponse<NewMinerI>>(
      new AddMinerReuest(settings),
      {
        onLoadingStatusChanged: setLoading,
      }
    );
    if (!response) return;
    dispatch(addNewMinerToStore(response.Record));
    onSuccess(notifs.ok.success);
  };

  return {
    inactive: selectedMinerTableTab === Tab.UNKNOWN,
    savedSettings,
    loading,
    hasClonedSetting,

    onAddMiner,
  };
};
